import { Component, OnInit, Input, ChangeDetectorRef, ElementRef, SimpleChanges, OnChanges, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EditorService } from '../bookeditoption/editor.service';
import { EditOptionService } from '../bookeditoption/editOptions.service';
import { Book } from '../../shared/models/book';
import { BookData } from '../../shared/models/bookData';
import { EnrichmentPage } from '../../shared/models/enrichmentPage';
import { Page } from '../../shared/models/page';
import * as _ from 'lodash'
import { PouchdbService } from '../../shared/pouchDb.service';

@Component({
    selector: 'app-fullview',
    templateUrl: './fullview.component.html',
    styleUrls: ['./fullview.component.css', '../../ELE/ELE.component.css']
})
export class FullviewComponent implements OnInit {
    @Input() pageContent: any;
    @Input() bookObj: Book;
    @Input() bookDataObj: BookData;
    @Input() currentLoadingPage: EnrichmentPage;
    @Input() pageObj: Page;
    @Input() rootTabActive: boolean;
    @Input() parent: any;
    @Input() updateFromPageenrichState: any


    @Output() callBackFromFullview: EventEmitter<any> = new EventEmitter<string>();
    @Output() callBackFromFullviewForPageEnrich: EventEmitter<any> = new EventEmitter<string>();
    public fullViewPageNumber: any;
    public formFullViewArray = [];
    public currentPageFullView: any;
    relaodEditor = true;
    localDB;
    currentPageFullViewId: any;
    duplicatePageNotEditor = false;
    public showFullViewHeader: boolean = false;

    constructor(public pouchService: PouchdbService, private cdr: ChangeDetectorRef, private ele: ElementRef) {

        this.localDB = pouchService.localDB;
    }

    ngOnChanges(changes: SimpleChanges) {

    }

    ngOnInit() {
        this.initializeEditor()
    }


    ngAfterViewInit() {

        var self = this;

        setTimeout(function () {
            if (document.getElementsByClassName('fullViewHeaderToolBar')[0]) {
                self.showFullViewHeader = true;
                document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '100%';
            }
        }, 500);

        setTimeout(function () {
            if (document.getElementsByClassName('fullViewHeaderToolBar')[0]) {
                self.showFullViewHeader = false;
                document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '0%';
            }
        }, 2000);

    }
    getPageContent(id, ) {
        var self = this;
        this.localDB.find({
            selector: { type: 'pageContent', _id: id },
        }).then(function (result) {
            if (result.docs.length > 0) {

                self.relaodEditor = false;

                setTimeout(() => {
                    self.relaodEditor = true;

                    self.pageContent = result.docs[0].pageContent;

                }, 10);
            }
        }).catch(function (err) {

        });
    }

    initializeEditor() {

        this.currentPageFullView = undefined;

        if (this.updateFromPageenrichState == 'presentation') {
            this.formFullViewArray = [];

            if (this.pageObj.enrichment_page) {

                this.updateFullViewArray(this.pageObj.enrichment_page)

            }

            if (this.formFullViewArray.length) {

                this.getPageContent(this.formFullViewArray[0].contentDocId);

                this.currentPageFullView = this.formFullViewArray[0];
                this.currentPageFullViewId = this.currentPageFullView.id;
            }
        }

        else {

            this.formFullViewArray = [];
            for (var property in this.bookDataObj) {
                if (this.bookDataObj[property] != undefined)
                    if (this.bookDataObj[property].pageNumber) {
                        this.formFullViewArray.push(this.bookDataObj[property]);

                        if (this.bookDataObj[property].children) {

                            this.updateFullViewArray(this.bookDataObj[property].children)

                        }
                    }
            }

            if (this.pageObj) {

                this.callBackFromFullview.emit('initialLoading');
            }

            this.currentPageFullView = this.pageObj;
            this.currentPageFullViewId = this.currentPageFullView.id;
        }
    }

    updateFullViewArray(object) {

        for (var i = 0; i < object.length; i++) {

            this.formFullViewArray.push(object[i]);

            if (object[i].children.length > 0) {
                this.updateFullViewArray(object[i].children)
            }

        }

    }

    onPrevious() {
        // this.currentPageFullView = undefined;
        if (this.parent == 'createdELE' || this.parent == 'EBE') {

            if (this.updateFromPageenrichState != undefined) {
                var self = this;
                var index = _.findIndex(this.formFullViewArray, function (o) {
                    return o.id == self.currentPageFullView.id;
                });

                this.currentPageFullView = this.formFullViewArray[index - 1];
                this.currentPageFullViewId = this.currentPageFullView.id;

                this.callBackFromFullviewForPageEnrich.emit(this.currentPageFullView.contentDocId);

            }

            else {

                if (this.pageObj.pageNumber > 0) {

                    var self = this;
                    var index = _.findIndex(this.formFullViewArray, function (o) {
                        return o.id == self.pageObj.id;
                    });

                    this.pageObj = this.formFullViewArray[index - 1];
                    this.currentPageFullView = this.pageObj;

                    this.callBackFromFullview.emit(this.pageObj);
                    this.currentPageFullViewId = this.currentPageFullView.id;
                    this.currentPageFullView = undefined;


                }
            }
        }
        else {
            this.fullViewPageNumber = this.fullViewPageNumber - 1;
        }
    }


    onNext() {

        // this.currentPageFullView = undefined;

        if (this.parent == 'createdELE' || this.parent == 'EBE') {

            if (this.updateFromPageenrichState != undefined) {
                var self = this;
                var index = _.findIndex(this.formFullViewArray, function (o) {
                    return o.id == self.currentPageFullView.id;
                });

                this.currentPageFullView = this.formFullViewArray[index + 1];
                this.currentPageFullViewId = this.currentPageFullView.id;
                this.getPageContent(this.currentPageFullView.contentDocId);

            }

            else {

                var self = this;


                var index = _.findIndex(this.formFullViewArray, function (o) {
                    return o.id == self.pageObj.id;
                });

                this.pageObj = this.formFullViewArray[index + 1];
                this.currentPageFullView = this.pageObj;

                this.callBackFromFullview.emit(this.pageObj);
                this.currentPageFullViewId = this.currentPageFullView.id;
                this.currentPageFullView = undefined;

            }

        }
        else {
            this.fullViewPageNumber = this.fullViewPageNumber + 1;
        }
    }
    setCurrentLoadingPage() {
        if (this.updateFromPageenrichState == undefined) {
            var res = this.pageObj.type == 'blankPage' || this.pageObj.type == 'template' || this.pageObj.type == 'mindmap' || this.pageObj.type == 'pageFromBook' || this.pageObj.type == 'duplicateAsImage' || this.pageObj.type == 'duplicateAsPage';
            return res;
        }
        else if (this.updateFromPageenrichState != undefined) {
            if (this.currentPageFullView.type == 'duplicateAsPage' && this.currentPageFullView.description.url.length > 0) {
                this.duplicatePageNotEditor = true;
                return false;
            }
            else {
                var res = this.currentPageFullView.type == 'blankPage' || this.currentPageFullView.type == 'template' || this.currentPageFullView.type == 'mindmap' || this.currentPageFullView.type == 'pageFromBook' || this.currentPageFullView.type == 'duplicateAsImage' || this.currentPageFullView.type == 'duplicateAsPage';
                return res;
            }
        }
    }

    closeEnrichmentsFullView() {
        this.showFullViewHeader = false;
        this.callBackFromFullviewForPageEnrich.emit('closeEnrichmentsFullView');
    }

    openNewWindow(link) {
        window.open(link);
    }

    onFullViewHeaderMouseEnter() {
        this.showFullViewHeader = true;
        document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '100%';
    }

    onFullViewHeaderMouseLeave() {
        this.showFullViewHeader = false;
        document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '0%';
    }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/fullView/fullview.component.ts